export const MESSAGING_WINDOW_24_HOURS = 24 * 60 * 60;

export const MESSAGING_WINDOW_CHANNEL_TYPES = [
  'Channel::Whatsapp',
  'Channel::Iungo',
];

export const hasMessagingWindowTimer = (channelType, medium = '') => {
  if (MESSAGING_WINDOW_CHANNEL_TYPES.includes(channelType)) {
    return true;
  }

  return channelType === 'Channel::Twilio' && medium === 'whatsapp';
};

export const getRemainingSeconds = expiresAt => {
  if (!expiresAt) return 0;

  return Math.max(0, expiresAt - Math.floor(Date.now() / 1000));
};

// Per Meta's rules, the 24h window only renews when the contact sends a
// message (incoming, non-private). Agent/outgoing replies never extend it.
export const shouldRefreshMessagingWindow = message =>
  message.message_type === 0 && !message.private;

export const buildMessagingWindowExpiresAt = message =>
  message.created_at + MESSAGING_WINDOW_24_HOURS;

export const formatRemainingTime = totalSeconds => {
  const safeSeconds = Math.max(0, totalSeconds);
  const hours = Math.floor(safeSeconds / 3600);
  const minutes = Math.floor((safeSeconds % 3600) / 60);
  const seconds = safeSeconds % 60;

  return [hours, minutes, seconds]
    .map(value => String(value).padStart(2, '0'))
    .join(':');
};

export const mergeMessagingWindowExpiresAt = (currentValue, nextValue) => {
  if (!nextValue) return currentValue;
  if (!currentValue) return nextValue;

  return Math.max(currentValue, nextValue);
};
